export default {"src":"/_next/static/media/icon_hamburger_chat.11cc5032.svg","height":23,"width":24,"blurWidth":0,"blurHeight":0};